/* eslint-disable no-return-assign */
import React, { PureComponent, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import { Card, CardBody, Col, Row, Container } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import NotificationSystem from 'rc-notification';
import columns from './components/Columns';
import MatTable from '../../shared/components/material-table';
import GraphQL from '../../GraphQL';
import SchoolGradeForm from './components/Form';
import Modal from '../../shared/components/Modal';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import {
  schoolGradeListAll,
  removeSchoolGradeMutation,
  saveSchoolGradeMutation,
} from '../../shared/queries/SchoolGrade';
import {
  showNotification,
  showNotificationAutoDestroy,
} from '../../shared/components/ShowNotification';

let notificationInstance = null;

class SchoolGrade extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
      data: [],
      formOn: false,
      modal: false,
      selectedDto: {},
    };
    this.deleteItem = this.deleteItem.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  componentDidMount() {
    NotificationSystem.newInstance({}, (n) => (notificationInstance = n));
    this.loadData();
  }

  componentWillUnmount() {
    notificationInstance.destroy();
  }

  loadData = () => {
    this.showLoading();
    const dataQuery = schoolGradeListAll();
    const { t } = this.props;
    GraphQL(dataQuery, {})
      .then((res) => {
        this.hideLoading();
        let schoolGradeList = res.schoolGradeListAll;
        schoolGradeList = schoolGradeList.map((item) => ({
          ...item,
          activeDescription: t(`general.yesno.${item.active}`),
        }));
        this.setState({ data: schoolGradeList });
      })
      .catch(() => {
        this.hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('notifications.error-to-loading')
        );
      });
  };

  addItemClickHandler = () => {
    const { data } = this.state;
    let newOrder = 0;
    if (data[data.length - 1]) {
      newOrder = data[data.length - 1].order + 1;
    }
    this.setState({
      formOn: true,
      selectedDto: { active: true, id: 0, order: newOrder },
    });
  };

  editItemClickHandler = (evt, rowData) => {
    const clickedItem = {
      ...rowData,
    };
    this.setState({ formOn: true, selectedDto: clickedItem });
  };

  removeItemClickHandler = (evt, rowData) => {
    const clickedItem = {
      ...rowData,
    };
    this.setState({ selectedDto: clickedItem });
    this.toggleModal();
  };

  deleteItem = () => {
    this.toggleModal();
    this.showLoading();
    const { selectedDto } = this.state;
    const { t } = this.props;
    const removeQuery = removeSchoolGradeMutation(selectedDto.id);
    GraphQL(removeQuery, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-removed')
        );
        this.loadData();
        this.hideLoading();
      })
      .catch(() => {
        this.hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-remove')
        );
      });
  };

  backClickHandler = () => {
    this.setState({ formOn: false });
    this.loadData();
  };

  handleSubmit = (values) => {
    const { t } = this.props;
    this.showLoading();
    const mutationQuery = saveSchoolGradeMutation(values);
    GraphQL(mutationQuery, {})
      .then(() => {
        this.hideLoading();
        this.backClickHandler();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        this.hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-save')
        );
      });
  };

  toggleModal = () => {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  };

  notification = (color, title, message) =>
    showNotification(notificationInstance, color, title, message);

  showLoading() {
    const { dispatch } = this.props;
    dispatch(changeLoadingTrue());
  }

  hideLoading() {
    const { dispatch } = this.props;
    dispatch(changeLoadingFalse());
  }

  render() {
    const { t } = this.props;
    const { data, formOn, selectedDto, modal } = this.state;
    const content = formOn ? (
      <SchoolGradeForm
        onSubmit={this.handleSubmit}
        backHandler={this.backClickHandler}
        notification={this.notification}
        dto={selectedDto}
      />
    ) : (
      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MatTable
                    onRefreshClick={this.loadData}
                    onAddClick={this.addItemClickHandler}
                    onEditClick={this.editItemClickHandler}
                    onRemoveClick={this.removeItemClickHandler}
                    data={data}
                    columns={columns(t)}
                    pageSize={20}
                    deleteAction={this.toggleModal}
                    title={t('panels.serie')}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
    return (
      <Fragment>
        <Modal
          color="warning"
          title={t('notifications.attention')}
          btn="Warning"
          message={t('notifications.delete_modal')}
          toggle={this.toggleModal}
          modal={modal}
          onConfirm={this.deleteItem}
        />
        {content}
      </Fragment>
    );
  }
}

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(SchoolGrade)
);
